<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="Home"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            附录
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <!-- 1. 邮件书写规范及收件人检索操作示例 -->
            <div>
                <p class="titleClass">1. 邮件书写规范及收件人检索操作示例</p>
                <img v-show="addShowJia" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia()">
                <img v-show="addShowXia" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia()">
            </div>
            <div v-for="item in dataList" :key="item.id" v-show="showContent">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(item.id)">
            </div>
            <!-- 2. 员工报班优惠制度 -->
            <div>
                <p class="titleClass">2. 员工报班优惠制度</p>
                <img v-show="addShowJia1" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia1()">
                <img v-show="addShowXia1" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia1()">
            </div>
            <div v-for="item in dataList1" :key="item.id" v-show="showContent1">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent1(item.id)">
            </div>
            <!-- 3. 伯乐奖执行办法 -->
            <div>
                <p class="titleClass">3. 伯乐奖执行办法</p>
                <img v-show="addShowJia2" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia2()">
                <img v-show="addShowXia2" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia2()">
            </div>
            <div v-for="item in dataList2" :key="item.id" v-show="showContent2">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent2(item.id)">
            </div>
            <!-- 4. 合同附加条款 -->
            <div>
                <p class="titleClass">4. 差旅费用标准管理规定</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent4">
            </div>
            <div>
                <p class="titleClass">5. 合同附加条款</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent3">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            addShowJia: true,
            addShowXia: false,
            showContent: false,
            addShowJia1: true,
            addShowXia1: false,
            showContent1: false,
            addShowJia2: true,
            addShowXia2: false,
            showContent2: false,
            dataList: [{
                    title: "1.1 书写规范",
                    id: "31"
                },
                {
                    title: "1.2 收件人检索操作流程",
                    id: "32"
                }
            ],
            dataList1: [{
                    title: "2.1 员工优惠报名的适用范围",
                    id: "41"
                },
                {
                    title: "2.2 员工优惠报名的标准",
                    id: "42"
                },
                {
                    title: "2.3 员工优惠报名注意事项",
                    id: "43"
                },
                {
                    title: "2.4 员工优惠 OA 申请流程及填写规范",
                    id: "44"
                }
            ],
            dataList2: [{
                    title: "3.1 “伯乐奖”推荐细则",
                    id: "51"
                },
                {
                    title: "3.2 “伯乐奖”推荐流程",
                    id: "52"
                },
                {
                    title: "3.3 “伯乐奖”领取流程",
                    id: "53"
                }
            ],
        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "1116"
                }
            })
        },
        addGetContent(i) {
            if (i == 31) {
                this.$router.push({
                    name: 'Appendix1',
                    params: {
                        code: "12"
                    }
                });
            } else if (i == 32) {
                this.$router.push({
                    name: 'Appendix2'
                });
            } else if (i == 33) {
                this.$router.push({
                    name: 'Administrative3',
                    params: {
                        code: "13"
                    }
                });
            } else if (i == 34) {
                this.$router.push({
                    name: 'Administrative4',
                    params: {
                        code: "14"
                    }
                });
            }
        },
        addGetContent1(id) {
            if (id == 41) {this.$router.push({name: "Appendix1",params:{code:'13'}})
            } else if (id == 42) {
                this.$router.push({
                    name: "Appendix3"
                })
            } else if (id == 43) {
                this.$router.push({
                    name: "Appendix1",
                    params:{code:"14"}
                })
            } else if (id == 44) {
                this.$router.push({
                    name: "Appendix4"
                })
            }
        },
        addGetContent2(id){
            if(id == 51){
                this.$router.push({name:"Appendix5"})
            } else if(id == 52){
                this.$router.push({name:"Appendix1", params:{code:"15"}})
            } else if(id == 53){
                this.$router.push({name:"Appendix1", params:{code:"16"}})
            }
        },
        addGetContent3(){
            this.$router.push({name:"Appendix1",params:{code:'17'}})
        },
        addGetContent4(){
            this.$router.push({name:"Appendix6"})   
        },
        addGetJia() {
            this.addShowXia = true;
            this.showContent = true;
            this.addShowJia = false;
            if (this.addShowXia1 == true || this.addShowXia2 == true) {
                this.addShowXia1 = false;
                this.showContent1 = false;
                this.addShowJia1 = true;
                this.addShowXia2 = false;
                this.showContent2 = false;
                this.addShowJia2 = true;
            }
        },
        addGetXia() {
            this.addShowXia = false;
            this.showContent = false;
            this.addShowJia = true;
        },
        addGetJia1() {
            this.addShowXia1 = true;
            this.showContent1 = true;
            this.addShowJia1 = false;
            if (this.addShowXia == true || this.addShowXia2 == true) {
                this.addShowXia = false;
                this.showContent = false;
                this.addShowJia = true;
                this.addShowXia2 = false;
                this.showContent2 = false;
                this.addShowJia2 = true;
            }
        },
        addGetXia1() {
            this.addShowXia1 = false;
            this.showContent1 = false;
            this.addShowJia1 = true;
        },
        addGetJia2() {
            this.addShowXia2 = true;
            this.showContent2 = true;
            this.addShowJia2 = false;
            if (this.addShowXia == true || this.addShowXia1 == true) {
                this.addShowXia = false;
                this.showContent = false;
                this.addShowJia = true;
                this.addShowXia1 = false;
                this.showContent1 = false;
                this.addShowJia1 = true;
            }
        },
        addGetXia2() {
            this.addShowXia2 = false;
            this.showContent2 = false;
            this.addShowJia2 = true;
        },
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}

.box-box {
    background: rgba(244, 244, 244, 1);
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 81%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 18px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div .titleCotent {
    width: 80% !important;
    margin-left: 34px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Appendix/appendix.vue